import { Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { InputConverter, InputConverterFunc } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';

export interface ITab {
    name: string;
    active: boolean;
}

export let TabConverter: InputConverterFunc<ITab> = (value: any) => {
    if (typeof value === 'string') { return JSON.parse(value) as ITab; }
    return value;
};

export let TabArrayConverter: InputConverterFunc<ITab[]> = (value: any) => {
    if (typeof value === 'string') { return JSON.parse(value) as ITab[]; }
    return value;
};
// TODO: Remove this. Applications should do tabs on their own.
@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-tabs',
    styleUrls: ['../../sharedStyles/base.scss'],
    templateUrl: './tabs.component.html'
})
export class TabsComponent extends BaseComponent {
    get includeGoogleAnalytics() { return false; }

    @InputConverter(TabArrayConverter)
    @Input() tabs: ITab[];
    @Output() readonly tabChanged: EventEmitter<ITab> = new EventEmitter();

    @Input()
    get activeTab() { return this.tabs.find(t => t.active); }

    constructor(_vcr: ViewContainerRef) {
        super(_vcr, true);
        this.registerEvent('tabchanged', this.tabChanged);
    }

    @Input()
    activateTab = (tab: string | ITab) => {
        if (typeof tab === 'string') {
            tab = this.tabs.find(t => t.name === tab);
        }
        const pt = tab;
        if (pt && this.activeTab.name !== pt.name) {
            this.tabs.forEach(t => {
                if (t.name !== pt.name) {
                    t.active = false;
                } else {
                    t.active = true;
                }
            });
            this.tabChanged.emit(this.activeTab);
        }
    }
}
